import { useContext, useState } from 'react';
import { Add as AddIcon } from '@mui/icons-material';
import ProofLinkPrompt from './ProofLinkPrompt';
import useApi from '@/lib/api/useApi';
import RubricsPortfolioContext from '@/lib/contexts/RubricsPortfolioContext';
import AddProofLinkButton from './AddProofLinkButton';
import useRubricsPortfolioApiEndpoint from '../../../../../useRubricsPortfolioApiEndpoint';
import { type RubricProofLink } from '@/lib/types';
import { FormattedMessage } from 'react-intl';

type AddProofLinkProps = {
  levelId: number;
};

const AddProofLink = ({ levelId }: AddProofLinkProps) => {
  const api = useApi();
  const rubricsPortfolioApiEndpoint = useRubricsPortfolioApiEndpoint();

  const [, setPortfolio] = useContext(RubricsPortfolioContext);

  const [addPromptOpen, setAddPromptOpen] = useState(false);
  const [saving, setSaving] = useState(false);

  const saveNewProofLink = async (newProof: string): Promise<void> => {
    setAddPromptOpen(false);
    setSaving(true);

    const proofLink = await api.post<RubricProofLink>(
      `${rubricsPortfolioApiEndpoint}/proof-links/${levelId}`,
      {
        link: newProof,
      },
    );

    setPortfolio(portfolio => {
      if (typeof portfolio.proofLinks[levelId] === 'undefined') {
        portfolio.proofLinks[levelId] = {};
      }

      portfolio.proofLinks[levelId][proofLink.id] = proofLink;
    });

    setSaving(false);
  };

  return (
    <>
      <AddProofLinkButton
        onClick={() => setAddPromptOpen(true)}
        startIcon={<AddIcon />}
        disabled={saving}
      >
        <FormattedMessage id="portfolio.level.attachments.proof.proof_link.add.button" />
      </AddProofLinkButton>
      <ProofLinkPrompt
        open={addPromptOpen}
        onOk={saveNewProofLink}
        onCancel={() => setAddPromptOpen(false)}
      />
    </>
  );
};

export default AddProofLink;
